import { useCallback } from 'react';
import { PlanEntitlementKey } from '../../api/graphql/generated';
import { useIsFeatureBetaUserLazy } from '../../api/hooks/feature.hooks';
import { hasEntitlement } from './plan-entitlement-utils';
import { useGetPlanSubscriptionEntitlements } from './plan-hooks';

export const useHasEntitlement = (key: PlanEntitlementKey): boolean => {
  const hasEntitlementLazy = useHasEntitlementLazy();
  return hasEntitlementLazy(key);
};

export type HasEntitlementCallback = (key: PlanEntitlementKey) => boolean;

export const useHasEntitlementLazy = (): HasEntitlementCallback => {
  const isBetaUser = useIsFeatureBetaUserLazy();
  const entitlements = useGetPlanSubscriptionEntitlements();

  const fn = useCallback<HasEntitlementCallback>(
    (key: PlanEntitlementKey): boolean => {
      return isBetaUser(key) || hasEntitlement({ entitlements, key });
    },
    [entitlements, isBetaUser]
  );

  return fn;
};
